(function () {
  function initKarinexMenu() {
    var menu = document.getElementById('custom-mobile-menu');
    var backdrop = document.getElementById('cmm-backdrop');
    var closeBtn = document.getElementById('cmm-close');
    var backBtn = document.getElementById('cmm-back');
    var backLabel = document.getElementById('cmm-back-label');
    if (!menu) return;

    var lastFocused = null;
    var savedScrollY = 0;
    var savedThemeColor = null;
    var l2Panel = menu.querySelector('.kx-menu__panel--l2');
    var l1Panel = menu.querySelector('.kx-menu__panel--l1');
    var subPanels = menu.querySelectorAll('.kx-menu__sub');

    function lightHaptic() {
      if (window.navigator && window.navigator.vibrate) {
        try { window.navigator.vibrate(8); } catch (e) {}
      }
    }

    function showSub(key) {
      subPanels.forEach(function (s) {
        if (s.getAttribute('data-sub') === key) {
          s.removeAttribute('hidden');
        } else {
          s.setAttribute('hidden', '');
        }
      });
    }

    function drillDown(key, parentLabel) {
      lightHaptic();
      showSub(key);
      if (backLabel) backLabel.textContent = parentLabel || 'Zurück';
      menu.classList.add('is-l2');
      if (l2Panel) {
        l2Panel.setAttribute('aria-hidden', 'false');
        l2Panel.scrollTop = 0;
      }
      if (l1Panel) l1Panel.setAttribute('aria-hidden', 'true');
      setTimeout(function () { if (backBtn) backBtn.focus(); }, 200);
    }

    function goBack() {
      lightHaptic();
      menu.classList.remove('is-l2');
      if (l2Panel) l2Panel.setAttribute('aria-hidden', 'true');
      if (l1Panel) l1Panel.setAttribute('aria-hidden', 'false');
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 200);
    }

    function openMenu() {
      lastFocused = document.activeElement;
      // iOS Safari tints its chrome (status bar + address bar) from the
      // theme-color meta, which header.js keeps at the header background.
      // Left untouched it reads as a stale gray strip above the open
      // drawer — retint it to the drawer bg and restore on close.
      var themeMeta = document.head.querySelector('meta[name="theme-color"]');
      if (themeMeta) {
        savedThemeColor = themeMeta.getAttribute('content');
        themeMeta.setAttribute('content', '#FAFAFA');
      }
      menu.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      // Hook for CSS to suppress page floats (PDP pills, countdown) and
      // drop the sticky header below the drawer while it is open.
      document.body.classList.add('kx-drawer-open');
      // iOS-Safari-safe body scroll lock: pin <body> at -scrollY so the
      // page underneath cannot move while the drawer is open.
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      var b = document.body.style;
      b.position = 'fixed';
      b.top      = '-' + savedScrollY + 'px';
      b.left     = '0';
      b.right    = '0';
      b.width    = '100%';
      b.overflow = 'hidden';
      var nativeDrawer = document.getElementById('Details-menu-drawer-container');
      if (nativeDrawer) {
        nativeDrawer.removeAttribute('open');
        nativeDrawer.classList.remove('menu-open');
      }
      document.body.classList.remove('overflow-hidden');
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 220);
    }

    function closeMenu() {
      var themeMeta = document.head.querySelector('meta[name="theme-color"]');
      if (themeMeta && savedThemeColor) {
        themeMeta.setAttribute('content', savedThemeColor);
      }
      menu.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('kx-drawer-open');
      // Release the body lock and restore the exact pre-open scroll
      // position — without this iOS jumps the page to top.
      var b = document.body.style;
      b.position = '';
      b.top      = '';
      b.left     = '';
      b.right    = '';
      b.width    = '';
      b.overflow = '';
      window.scrollTo(0, savedScrollY);
      setTimeout(function () {
        menu.classList.remove('is-l2');
        if (l2Panel) l2Panel.setAttribute('aria-hidden', 'true');
        if (l1Panel) l1Panel.setAttribute('aria-hidden', 'false');
      }, 540);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeMenu(); });
    if (backdrop) backdrop.addEventListener('click', closeMenu);
    if (backBtn) backBtn.addEventListener('click', function (e) { e.preventDefault(); goBack(); });

    menu.querySelectorAll('[data-drill]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        drillDown(btn.getAttribute('data-drill'), btn.getAttribute('data-parent-label'));
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        if (menu.classList.contains('is-l2')) goBack();
        else closeMenu();
      }
    });

    /* Hijack the theme's hamburger trigger — toggle (open / close) */
    document.body.addEventListener('click', function (e) {
      if (window.innerWidth > 990) return;
      var trigger = e.target.closest('.header__icon--menu, [data-header-drawer], .header__drawer summary, .header__icon--menu span');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
      return false;
    }, true);

    /* Haptic on category and product taps */
    menu.querySelectorAll('[data-haptic], .kx-menu__bs-card').forEach(function (el) {
      el.addEventListener('click', lightHaptic);
    });

    /* Swipe gestures: L1 swipe-left closes; L2 swipe-right goes back */
    var startX = null, startY = null;
    menu.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }
    }, { passive: true });
    menu.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var t = e.changedTouches[0] || {};
      var dx = (t.clientX || startX) - startX;
      var ady = Math.abs(startY - (t.clientY || startY));
      if (ady < 40) {
        if (menu.classList.contains('is-l2') && dx > 60) {
          goBack();
        } else if (!menu.classList.contains('is-l2') && dx < -60) {
          closeMenu();
        }
      }
      startX = null;
      startY = null;
    });

    /* Focus trap */
    menu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !menu.classList.contains('is-open')) return;
      var scope = menu.classList.contains('is-l2') ? l2Panel : l1Panel;
      var headerScope = menu.querySelector(menu.classList.contains('is-l2') ? '.kx-menu__header-state--l2' : '.kx-menu__header-state--l1');
      var nodes = [];
      if (headerScope) nodes = nodes.concat(Array.prototype.slice.call(headerScope.querySelectorAll('a[href], button:not([disabled])')));
      if (closeBtn) nodes.push(closeBtn);
      if (scope) {
        var visible = scope.querySelectorAll('a[href], button:not([disabled])');
        nodes = nodes.concat(Array.prototype.slice.call(visible).filter(function (n) {
          return !n.closest('[hidden]');
        }));
      }
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKarinexMenu);
  } else {
    initKarinexMenu();
  }
})();
